import React from 'react';

import Delete from 'Components/Partials/Modals/Delete';
import {IndexTable} from 'Components/Utilities';

import AdminLayout from 'Pages/Admin/AdminLayout';

import AdminAgendaApi from 'Services/Api/Admin/Agenda';
import {translationFromJson} from 'Services/TranslationHelpers2';

export default class AgendaIndex extends React.Component {
    /**
     * @var columns
     * @type {array}
     */
    columns = [
        {
            label: 'Title',
            value: (record) => translationFromJson(record.title),
            type: 'callback',
            orderable: null,
        },
        {
            label: 'Start Date',
            value: 'start_date_time',
            type: 'date',
            orderable: 'start_date_time'
        },
        {
            label: 'Start Time',
            value: 'start_date_time',
            type: 'time',
            orderable: 'start_date_time'
        },
    ];

    /**
     * @method getRowActions
     * @param {object} item
     */
    getRowActions = (item) => {
        return [
            {
                type: "link",
                to: "/admin/agenda/store/"+item.id,
                text: "Update"
            },
            {
                type: "modalTrigger",
                component: Delete,
                props: {
                    message: `
                        Are you sure you want to delete this agenda item?
                        This action cannot be reversed.
                        All user bookings will be deleted too.
                        You can deactivate the item instead, to prevent it from displaying
                        on the site but preserve any user bookings.
                    `,
                    itemId: item.id,
                    onDeleteApi: AdminAgendaApi.delete
                },
                text: 'Delete'
            }
        ];
    }

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        return (
            <AdminLayout title="Admin Agenda">
                <IndexTable
                    columns={this.columns}
                    displaySearchBar={true}
                    storeLink="/admin/agenda/store"
                    loadDataCallback={(data) => AdminAgendaApi.get(null, data)}
                    rowActions={this.getRowActions}
                    eventApi={AdminAgendaApi}
                />
            </AdminLayout>
        )
    }
}